module.exports = __webpack_public_path__ + "img/xiami.0da5cc02.png";